import { Dispatch, SetStateAction } from 'react';
import { ActionMeta } from 'react-select';
import { isObject } from 'underscore';

import { assertIsArray } from '@/utils/assertions/assert-is-array';
import { TagOption } from './tags-select.types';
import { IEventTag } from '@/types/projects.types';

type Params = {
  newValue: unknown;
  actionMeta: ActionMeta<unknown>;
  handleAdd: () => void;
  onChange?: (selectedTags: IEventTag[]) => void;
  setSelectedTags: Dispatch<SetStateAction<TagOption[]>>;
  setDisplayColorPicker: Dispatch<SetStateAction<IEventTag | null>>;
};

const tagsSelectHandleChange = ({
  setDisplayColorPicker,
  setSelectedTags,
  onChange,
  newValue,
  actionMeta,
  handleAdd,
}: Params) => {
  const metaOption = actionMeta.option;
  try {
    assertIsArray<TagOption>(newValue);
  } catch (error) {
    console.error('Error asserting custom react option', error);
    return;
  }

  if (isObject(metaOption) && metaOption?.__isNew__) {
    handleAdd();
  } else {
    onChange?.(newValue.map((t) => t.meta));
    setSelectedTags(newValue);
  }

  // close color picker if value removed
  const valueRemoved = ['remove-value', 'clear', 'pop-value'].includes(actionMeta.action);
  if (valueRemoved) {
    setDisplayColorPicker(null);
  }
};

export default tagsSelectHandleChange;
